import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=abcb5318&scoped=true&"
import script from "./logistics.vue?vue&type=script&lang=js&"
export * from "./logistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcb5318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abcb5318')) {
      api.createRecord('abcb5318', component.options)
    } else {
      api.reload('abcb5318', component.options)
    }
    module.hot.accept("./logistics.vue?vue&type=template&id=abcb5318&scoped=true&", function () {
      api.rerender('abcb5318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lease/logistics.vue"
export default component.exports